"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keymirror = require("keymirror");

var _keymirror2 = _interopRequireDefault(_keymirror);

var _constant = require("../constant");

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VALUE = (0, _keymirror2.default)({
  WEB: null,
  ANDROID: null,
  IOS: null,
  FINO: null
});

var platform = function platform(ua) {
  var getUa = function getUa() {
    return ua || window.navigator.userAgent;
  };
  var getHost = function getHost() {
    return window.location.host || "";
  };
  var app = {
    isFino: function isFino() {
      return (/HyxFino/.test(getUa())
      );
    },
    isWeb: function isWeb() {
      return app.value === VALUE.WEB;
    },
    value: function value() {
      return app.isFino() ? VALUE.FINO : VALUE.WEB;
    },
    isKaopWeb: function isKaopWeb() {
      return _constant2.default.KAOP_MALL_HOST === getHost();
    }
  };

  var os = {
    isAndroid: function isAndroid() {
      return (/Android/i.test(getUa())
      );
    },
    isIOS: function isIOS() {
      return (/iPhone|iPad|iPad/i.test(getUa())
      );
    },
    isOther: function isOther() {
      return !os.isAndroid() && !os.isIOS();
    },
    value: function value() {
      return os.isIOS() ? VALUE.IOS : os.isAndroid() ? VALUE.ANDROID : VALUE.OTHER;
    }
  };

  return {
    app: app,
    os: os
  };
};

exports.default = platform;